export const EMPLOYEES_BULK_CREATE_FILE_VERSION = '1.15';

export const EMPLOYEES_BULK_CREATE_FILE_DATA_STARTING_LINE = 3;

export const EMPLOYEES_BULK_CREATE_FILE_MAX_LINE = 15000;

export const EMPLOYEES_MULTI_COMPANY_BULK_CREATE_FILE_VERSION = '1.2';

export const EMPLOYEE_MIN_LEGAL_WORK_AGE = 1;

export const EMPLOYEE_MAX_DEDUCTIBLE_AGE = 70;

export const COMPANY_ID_ALLOWING_CSP_CODE = [10155];
